"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PREVIEW_QUERIE = exports.CHIP_HEIGHT = void 0;
const SEARCH_PREVIEW_QUERIE = exports.SEARCH_PREVIEW_QUERIE = 'search-preview-querie';
const CHIP_HEIGHT = exports.CHIP_HEIGHT = 35;